import React from 'react';
import {connect} from 'react-redux';
import { CONFIG } from '../../../../../config';
import {cekCookies} from '../../../../../actions';
import __ from 'lodash';

import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import accountManagement from '../../../../../apis/accountManagement';
import KelasSearch from '../../../../../entity/KelasSearch';
import KelasParalelSearch from '../../../../../entity/KelasParalelSearch';

import { Alert } from 'react-bootstrap';
import DropdownKelas from '../../masterDropDown/DropdownKelas';
import DropdownKelasParalel from '../../masterDropDown/DropdownKelasParalel';


class ImportSiswa extends React.Component{
    constructor(props){
        super(props);
        this.state = { 
            error: null,
            resMessage: {}, 
            alertShow: false,          
            isFetching: false,
            idKelasSelected:'',
            idKelasPselected:'',
            file: '',
            dataKelas:[],
            kelasP:[]
        }
        this.handleSubmit=this.handleSubmit.bind(this);
        this.handleOnChangeKelas=this.handleOnChangeKelas.bind(this);
        this.handleOnChangeKelasParalel=this.handleOnChangeKelasParalel.bind(this);
        this.onFileChange=this.onFileChange.bind(this);
    }

    async componentDidMount(){
        this.setState({isFetching: true});
        await this.props.cekCookies();
        this.setState({isFetching: false});
        if(!__.isEmpty(this.props.account)){
            this.fetchKelas();
        }
    }

    fetchKelas = async () =>{
        this.setState({isFetching: true});
        //fetch sekolah dulu
        const resSekolah = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_SEKOLAH + this.props.account.idSekolah).catch(function(error){
        })

        //fetch kelas setelah dapat data sekolah
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS, {KelasSearch, ["kodeJenjangSekolah"]: resSekolah.data.data.kodeJenjangSekolah}).catch(function(error){
        });

        // masukan data kelas ke dropdown
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    dataKelas: response.data.data
                })
            }
        }
        this.setState({isFetching: false});
    }

    handleOnChangeKelas = async (idKelas) =>{        
        this.setState({isFetching: true});
        this.setState({idKelasSelected:idKelas.target.value})
        this.setState({idKelasPselected:null})
        //fetch kelas pararelnya dulu
        const resKelasParalel = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS_PARALEL, {KelasParalelSearch,['idKelas']: idKelas.target.value, ['idSekolah']: this.props.account.idSekolah}).catch (function(error){
        })

        // masukan kelas paralel ke  dropdown
        this.setState({kelasP:[]});

        if(resKelasParalel){
            if(resKelasParalel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    kelasP: resKelasParalel.data.data
                })
            }
        }

        this.setState({isFetching: false});
    }

    handleOnChangeKelasParalel = async (idKp) =>{
        this.setState({idKelasPselected:idKp.target.value})
    }

    onFileChange = (event) => {        
		this.setState({
			file: event.target.files[0]
		});
    }
    
    loadAlert = () => {
        const {alertShow,resMessage } = this.state;
      
        if (alertShow && resMessage.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{resMessage.errorMessage}</strong>
            </Alert>
          );
        } else if  (alertShow && resMessage.errorCode != CONFIG.SUCCESS_ERROR_CODE){
            return (
                <Alert variant="warning" onClose={() => this.setState({ alertShow: false })} dismissible>   
                    <strong>{resMessage.errorMessage}</strong>
                </Alert>
              );
        }
    }

    // HANDLE SUBMIT FORM IMPORT SISWA
    handleSubmit = async (event)=> {
        this.setState({ isFetching: true })
        event.preventDefault();
        if(this.state.idKelasSelected!='' && this.state.idKelasPselected!=''){            
            let data = new FormData();
            data.append('idSekolah', this.props.account.idSekolah);
            data.append('idKelas', this.state.idKelasSelected);
            data.append('idKelasParalel', this.state.idKelasPselected);
		    data.append('file', this.state.file);
            const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SISWA_IMPORT,
                data 
            ).catch(function(error){})

            if(response) {
                this.setState({
                    resMessage: response.data.errorSchema,
                    isFetching: false,
                    alertShow:true,
                    idKelasSelected: '',
                    idKelasPselected: '',
                    file: ''
                });
                document.getElementById("file").value = "";
            }           
            
        }else{
            this.setState({isFetching: false});
            alert('Terjadi Kesalahan...')
        }
    } 
    
    render(){
        return(
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar />  
                    <div className="row">
                        <div className="col-md-12">
                            <h4>Import Siswa</h4>
                        </div>                         
                    </div>
                    {this.loadAlert()}   
                    <div className="row">
                        <div className="col-md-5">
                            <div class="card">
                                <div class="card-body">
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="form-group">
                                            <label>Pilih Kelas <span className="text-danger">*</span></label>
                                            <select className="form-control" value={this.state.idKelasSelected} onChange={this.handleOnChangeKelas} required>
                                                <option value="" selected disabled>~~ Pilih Kelas ~~</option>
                                                <DropdownKelas kelas={this.state.dataKelas} />
                                            </select> 
                                        </div>
                                        <div className="form-group">
                                            <label>Pilih Kelas <span className="text-danger">*</span></label>
                                            <select className="form-control" value={this.state.idKelasPselected} onChange={this.handleOnChangeKelasParalel} required>
                                                <option value="" selected disabled>~~ Pilih Kelas Paralel ~~</option>
                                                <DropdownKelasParalel kelasParalel={this.state.kelasP} />
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>File Excel <span className="text-danger">*</span></label>
                                            <input type="file" className="form-control" required 
                                            onChange={this.onFileChange} id="file"
                                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" />
                                        </div>
                                        <br />
                                        <button type="submit" value="Submit" className="btn btn-primary">
                                            <li className="fa fa-upload"> Upload</li>
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div class="card">
                                <div class="card-body">
                                    <h5>Prosedur Import Siswa :</h5>
                                    <ol>
                                        <li>Download format dokumen (.xlsx)&nbsp;</li>
                                        <li>Isi dokumen berdasarkan format yang sudah ditentukan</li>
                                        <li>Format dokumen wajib&nbsp;<span class="text-danger"><strong>*</strong></span><strong>.xlsx atau .xls</strong><span class="text-danger"><strong>*</strong></span></li>
                                        <li>PASTIKAN TIDAK ADA IMPORT FILE LEBIH DARI 1 KALI, KARENA AKAN MENYEBABKAN DUPLIKASI AKUN!!</li>
                                        <br/>
                                        <a class="btn btn-info pull-right" href={process.env.PUBLIC_URL + '/form_import_siswa.xlsx'}><li className="fa fa-download"> Download</li></a>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>  
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(ImportSiswa);

